<template>
    <add-item-form
        v-bind="formData"
        @created="onCreated"
    ></add-item-form>
</template>

<script>
  import Form from "../../../send-list/conversations/add-item-form";

  export default {
    components: {
      'add-item-form': Form,
    },

    props: {
      getFormUrl: String,
    },

    data() {
      return {
        formData: {},
      };
    },

    methods: {
      loadForm() {
        axios.get(this.getFormUrl)
          .then(({data: {...formData}}) => {
            this.formData = formData;
            this.$emit('initialized');
          })
          .catch(({response: {data: {message}}}) => {
            const payload = _.assign({}, message ? {message} : {});
            this.$emit('initialization-error', payload);
          });
      },

      onCreated() {
        this.$emit('created');
      },
    },

    mounted() {
      this.loadForm();
    },
  }
</script>
